import React, {Component, Fragment} from 'react';
import {Alert} from 'reactstrap';
import TagsList from '../../../shared/components/TagsList';
import Checkbox from "../../../shared/forms/Checkbox";
import formatRoleName from "../../models/utilities/formatRoleName";
import adminFormatRoleName from "../../../admin-app/models/formatRoleName";
import DisplayUserPhoto from "./DisplayUserPhoto";
import moment from 'moment';
import {connect} from "react-redux";
import Tooltip from "../../../shared/ui/Tooltip";

const getCurrentCertification = (user) => {
  let currentCertification = user.certifications.find(cert => {
    let startAt = moment(cert.startAt);
    let expireAt = moment(cert.expireAt);
    let today = moment();
    return (startAt.valueOf() < today.valueOf() && expireAt.valueOf() > today.valueOf())
  });

  if (currentCertification) {
    let startAt = moment(currentCertification.startAt);
    let expireAt = moment(currentCertification.expireAt);
    let today = moment();
    return `Expires in ${expireAt.diff(today, 'days')} days`
  } else {
    return `No certification`
  }
}

class UserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredUsers: this.props.users,
      filterByName: '',
      filterByRole: '',
      filterByStatus: 'active',
      sort: {
        prop: '',
        direction: '',
      },
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.filter != null) {
      this.filterByRole(this.props.filter);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.users != null) {
      this.setState({
        filteredUsers: this.props.users,
        filterByName: '',
        filterByRole: '',
        sort: {
          prop: '',
          direction: '',
        },
      });
    }
  }

  get filteredUsers() {
    let filteredUsers = this.props.users

    if (this.state.filterByStatus) {
      filteredUsers = filteredUsers.filter(user => {
        if (this.state.filterByStatus === 'active') {
          return user.active && user.user_apps && user.user_apps.fto
        } else {
          return !user.active || !user.user_apps || !user.user_apps.fto
        }
      })
    }

    if (this.state.filterByRole) {
      filteredUsers = filteredUsers.filter(user => user.roles.find(r => r.scope === this.state.filterByRole))
    }

    if (this.state.filterByName) {
      filteredUsers = filteredUsers.filter((user) => {
        return user
          .getFullNameReversed()
          .toLowerCase()
          .includes(this.state.filterByName.toLowerCase());
      })
    }

    return filteredUsers
  }

  // ----------------------
  // Methods
  // ----------------------

  filterByName(characters) {
    this.setState({
      filterByName: characters,
    });
  }

  filterByRole(roleScope) {
    this.setState({
      filterByRole: roleScope,
    });
  }

  filterByStatus(status) {
    this.setState({
      filterByStatus: status,
    });
  }

  sortByProperty(property) {
    if (property === this.state.sort.prop) {
      if (this.state.sort.direction === 'desc') {
        this.setState({
          sort: {
            prop: property,
            direction: 'asc',
          },
        });
      } else {
        this.setState({
          sort: {
            prop: property,
            direction: 'desc',
          },
        });
      }
    } else {
      this.setState({
        sort: {
          prop: property,
          direction: 'asc',
        },
      });
    }
  }

  enableDisableUser(user, checked) {
    this.props.onEnableDisableUser(user, checked)
  }

  formatUserRoleLocal(role) {
    if(this.props.userContext.scope === 'admin') {
      return adminFormatRoleName(role)
    }
    return formatRoleName(role)
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    console.log('USER TABLE')
    return (
      <Fragment>
        <form className="table-filters">
          <div className="form-group">
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="filterByRole">Filter status</label>
            <select
              className="form-control"
              id="filterByStatus"
              name="filterByStatus"
              onChange={event => this.filterByStatus(event.target.value)}
              value={this.state.filterByStatus}
            >
              <option value="active">Active</option>
              <option value="notActive">Not active</option>
            </select>
          </div>
          <div className="form-group">
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="filterByRole">Filter by role</label>
            <select
              className="form-control"
              id="filterByRole"
              name="filterByRole"
              onChange={event => this.filterByRole(event.target.value)}
              value={this.state.filterByRole}
            >
              <option value="">All</option>
              <option value="oit">{this.formatUserRoleLocal('oit')}</option>
              <option value="fto">{this.formatUserRoleLocal('fto')}</option>
              <option value="sup">{this.formatUserRoleLocal('sup')}</option>
              <option value="ftoc">{this.formatUserRoleLocal('ftoc')}</option>
              <option value="cstaff">{this.formatUserRoleLocal('cstaff')}</option>
              <option value="chief">{this.formatUserRoleLocal('chief')}</option>
              <option value="depadmin">Department Administrator</option>
            </select>
          </div>

          <div className="form-group">
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="searchByName">Search by name</label>
            <input
              className="form-control"
              id="searchByName"
              name="searchByName"
              onChange={event => this.filterByName(event.target.value)}
              placeholder="Search users"
              type="text"
              value={this.state.filterByName}
            />
          </div>
        </form>

        {!this.filteredUsers.length ? (
          <Alert color="primary">No Users for selected filters</Alert>
        ) : (
          <div className="table-scrollable">
            <table className="table table-stripped">
              <thead>
              <tr>
                <th style={{width: '90px'}}>
                  <div className="header">
                    <span>Photo </span>
                  </div>
                </th>
                <th onClick={() => this.sortByProperty('name')}>
                  <div className="header">
                    <span>Name </span>
                    <div className="filterActions">
                      <i className="fa fa-angle-up" />
                      <i className="fa fa-angle-down" />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Role </span>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Tags </span>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Phone </span>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Active </span>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Actions </span>
                  </div>
                </th>
              </tr>
              </thead>
              <tbody>
              {this.filteredUsers.map((user, index) => {
                return (
                  <tr key={user.guid}>
                    <td>
                      <DisplayUserPhoto
                        user={user}
                      />
                    </td>
                    <td>
                      <DisplayUserPhoto
                        user={user}
                        displayOnHover={true}
                      >
                        {user.getFullName()}
                      </DisplayUserPhoto>

                      <div style={{color: '#bf292a', fontSize: '0.9em'}}>{getCurrentCertification(user)}</div>
                    </td>
                    <td>{this.formatUserRoleLocal(user.roleScope)}</td>
                    <td>
                      <TagsList tags={user.tags} />
                    </td>
                    <td>
                      {' '}
                      <i className="fa fa-phone"/> &nbsp;{' '}
                      {user.getDefaultPhoneFormatted()}
                    </td>
                    <td>
                      {user.active && (
                        <Tooltip tip={user.user_apps.fto? "Click to Disable Access to FTO Software": "Click to Enable Access to FTO Software"}>
                          <Checkbox
                            checked={user.user_apps.fto}
                            label="Active"
                            onChange={(e) => this.enableDisableUser(user, e.target.checked)}/>
                        </Tooltip>)}
                      {user.active && <Tooltip tip={'Caution: Clicking Here Disables User From "ALL" Software Suites'}>
                        <button className="button small secondary"
                                onClick={() => this.props.onEnableDisableLoginAccess(user, false)}>
                            <span>Disable access</span>
                          </button>
                      </Tooltip>}
                      {!user.active && <Tooltip tip={
                        'Caution: Clicking Here Enables User From "ALL" Software Suites'
                      }><button className="button small primary"
                                               onClick={() => this.props.onEnableDisableLoginAccess(user, true)}>
                        <span>Enable access</span>
                      </button></Tooltip>}
                    </td>
                    <td className="td-actions">

                      {!this.props.actions && (
                        <Tooltip tip="Details">
                          <button
                            className="button default small"
                            onClick={() => this.props.onShowDetails(user.guid)}
                          >
                            <i className="fa fa-list" />
                          </button>
                        </Tooltip>
                      )}
                      {this.props.actions &&
                      this.props.actions.roles && (
                          <Tooltip tip="Details">
                            <button
                              className="button default small"
                              onClick={() => this.props.onShowDetails(user.guid)}
                            >
                              <i className="fa fa-list" />
                            </button>
                          </Tooltip>
                      )}
                      <Tooltip tip="Manage tags">
                        <button
                          className="button default small"
                          onClick={() => this.props.onManageTags(user.guid)}
                        >
                          <i className="fa fa-tags"/>
                        </button>
                      </Tooltip>

                      {//user.roleScope === 'oit' &&

                        <Tooltip tip="Change division">
                          <button
                        className="button default small"
                        onClick={() => this.props.onChangeDivision(user)}
                      >
                        <i className="fa fa-building-o"/>
                        </button></Tooltip>}
                      {user.hasTempPass &&  <Tooltip tip="Show temporary password"><button
                        className="button default small"
                        onClick={() => this.props.onShowPassword(user)}
                      >
                        <i className="fa fa-eye"/>
                      </button></Tooltip>}
                      {user.hasTempPass &&  <Tooltip tip="Resend temporary password" direction="left"><button
                        className="button default small"
                        onClick={() => this.props.onResendPassword(user.guid)}
                      >
                        <i className="fa fa-key"/>
                      </button></Tooltip>}
                    </td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext
  }
};

export default connect(mapStateToProps, null)(UserTable);
